import gql from 'graphql-tag'


export const initSearchBills = gql`
query initSearchBills($params: SearchBillsArgs!) {
  cashAssist {
    initSearchBills(params: $params)
  }
}
`


export const getStatisticsData = gql`
query getStatisticsData($requestId: ID!) {
	cashAssist {
		getStatisticsData(requestId: $requestId) {
			status
      progress
      data {
				...on StatisticBill {
		      id
					cardName
					cardNumber
					groupId
					number
					dateTime
					total
					isCancelled
					cashRegisterName
					userName
					cancellationUserName
					timer
					cancellationUserId
					cashRegisterId
					totalWithoutCancellation
					loyaltyCard {
						id
						name
					}
			    items {
			      id
			      price
			      total
			      amount
			      codeMWSt
			      discountPercent
			      flag
			      mul1
			      product {
			        name
			        code
			      }
			      inCafe
			    }
			  }
			}
    }
  }
}
`


